
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * FeedUpdateSubscriptionType enum
 */
class FeedUpdateSubscriptionType {
  /**
   * Initialize enum with a given value
   * @param {FeedUpdateSubscriptionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof FeedUpdateSubscriptionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!FeedUpdateSubscriptionType}
   * @param {!FeedUpdateSubscriptionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedUpdateSubscriptionType)) {
      throw new TypeError('Instance of FeedUpdateSubscriptionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!FeedUpdateSubscriptionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!FeedUpdateSubscriptionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === FeedUpdateSubscriptionType.NONE.value) {
      return 'NONE'
    }
    if (this.value === FeedUpdateSubscriptionType.PARTIAL.value) {
      return 'PARTIAL'
    }
    if (this.value === FeedUpdateSubscriptionType.FULL.value) {
      return 'FULL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!FeedUpdateSubscriptionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!FeedUpdateSubscriptionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!FeedUpdateSubscriptionType} Created enum
   */
  static fromObject (other) {
    return new FeedUpdateSubscriptionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
FeedUpdateSubscriptionType.NONE = new FeedUpdateSubscriptionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
FeedUpdateSubscriptionType.PARTIAL = new FeedUpdateSubscriptionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
FeedUpdateSubscriptionType.FULL = new FeedUpdateSubscriptionType(0 + 2)

export { FeedUpdateSubscriptionType };

/**
 * Fast Binary Encoding FeedUpdateSubscriptionType field model
 */
class FieldModelFeedUpdateSubscriptionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelFeedUpdateSubscriptionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelFeedUpdateSubscriptionType}
   * @param {FeedUpdateSubscriptionType=} defaults Default value, defaults is new FeedUpdateSubscriptionType()
   * @returns {!FeedUpdateSubscriptionType} Result value
   */
  get (defaults = new FeedUpdateSubscriptionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new FeedUpdateSubscriptionType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelFeedUpdateSubscriptionType}
   * @param {!FeedUpdateSubscriptionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelFeedUpdateSubscriptionType };
